export default __webpack_public_path__ + "static/media/feather_shopping-bag.9b475773.svg";